import type { CreateObjectDraftStepMode } from '../../../types'

export const shouldShowAddressMapButton = (
  mode: CreateObjectDraftStepMode = 'create',
) => mode === 'edit'
